import React, {useEffect, useState} from "react";
import Select from "react-select";
import {Row, Col, Card, Container, Input} from "reactstrap";

import 'react-toastify/dist/ReactToastify.css';


import {useDispatch} from "react-redux";

import {Link, useNavigate} from "react-router-dom";


import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import AuthSlider from "./authCarousel";

const Register = () => {
    document.title = "Registrar | Plantão Rápido";

    const history = useNavigate();
    const dispatch = useDispatch();
    const [message, setMessage] = useState('');
    const [ufs, setUfs] = useState([]);
    const [logoWhite, setLogoWhite] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);

    const [users, setUsers] = useState({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        crm: '',
        uf: '',
    });
    const [specialtyFilter, setSpecialtyFilter] = useState([]);
    const [selectedSpecialty, setSelectedSpecialty] = useState(null);
    const [cpfCnpj, setCpfCnpj] = useState(null);
    const [customDomainId, setCustomDomainId] = useState(null);
    const [footerTitle, setFooterTitle] = useState("MEDR");
    const [footerUrl, setFooterUrl] = useState("https://medr.com.br/");

    const [criteria, setCriteria] = useState({
        length: false,
        uppercase: false,
        number: false
    });

    useEffect(() => {
        const domain = window.location.hostname;

        const loadCustomDomainData = () => {
            try {
                const cachedData = localStorage.getItem(`custom_images_${domain}`);
                const cachedImages = cachedData ? JSON.parse(cachedData) : {};

                if (cachedImages.customDomainId) {
                    setCustomDomainId(cachedImages.customDomainId);
                }

                if (cachedImages.specialties && cachedImages.specialties.length > 0) {
                    setSpecialtyFilter(cachedImages.specialties);
                }

                if (cachedImages.titleFooter) {
                    setFooterTitle(cachedImages.titleFooter);
                }
                if (cachedImages.companyUrlFooter) {
                    setFooterUrl(cachedImages.companyUrlFooter);
                }
            } catch (error) {
                console.error('Erro ao carregar dados customizados:', error);
            }
        };

        loadCustomDomainData();

        const interval = setInterval(loadCustomDomainData, 500);
        const timeout = setTimeout(() => clearInterval(interval), 5000);

        const storedUfs = localStorage.getItem("ufs");

        if (storedUfs) {
            setUfs(JSON.parse(storedUfs));
        } else {
            ApiService.send("get", process.env.REACT_APP_URL_API + "address/states", [], false)
                .then((res) => {
                    const data = res.data;
                    const ufsData = data.map((uf) => ({
                        value: uf.code,
                        label: uf.name
                    }));
                    setUfs(ufsData);
                    localStorage.setItem("ufs", JSON.stringify(ufsData));
                })
                .catch((error) => {
                    console.error("Erro ao carregar estados:", error);
                });
        }

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    const validatePassword = (password) => {
        setCriteria({
            length: password.length >= 6,
            uppercase: /[A-Z]/.test(password),
            number: /[0-9]/.test(password)
        });
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setUsers(prevUsers => ({
            ...prevUsers,
            [name]: value
        }));

        if (name === 'password') {
            validatePassword(value);
        }
    };


    const handleCpfCnpjChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setCpfCnpj(formatCpfCnpj(value));

        const {name} = e.target;
        setUsers(prevUsers => ({
            ...prevUsers,
            [name]: value
        }));
    };
    const formatCpfCnpj = (value) => {
        let formattedValue = value.replace(/\D/g, '');

        if (formattedValue.length <= 11) {
            formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else if (formattedValue.length <= 14) {
            formattedValue = formattedValue.replace(/(\d{2})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d{1,4})$/, "$1/$2");
        } else {
            formattedValue = formattedValue.replace(/(\d{2})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d)/, "$1.$2");
            formattedValue = formattedValue.replace(/(\d{3})(\d{4})(\d{1,2})$/, "$1/$2-$3");
        }

        return formattedValue;
    };

    const handleUfChange = (selectedOption) => {
        setUsers(prevUsers => ({
            ...prevUsers,
            uf: selectedOption.value
        }));
    };

    const handleNextStep = async () => {
        if (currentStep === 1) {
            if ((!users.crm || !users.uf) && selectedSpecialty?.council_code === 'CRM') {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Por favor, preencha CRM e Estado.'
                });
                return;
            }
            try {

                if (selectedSpecialty?.council_code === 'CRM') {

                    const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}users/crm`, {
                        doc_number: users.crm,
                        state: users.uf
                    }, false);


                    const {data} = ApiService.handleApiResponse(response);

                    setUsers(prevUsers => ({
                        ...prevUsers,
                        name: data.nome
                    }));
                }
                setCurrentStep(prevStep => prevStep + 1);

            } catch (error) {
                ApiService.handleApiError(error);
            }

        }
    };

    const handlePreviousStep = () => {
        setCurrentStep(prevStep => prevStep - 1);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            if (users.password !== users.password_confirmation) {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'As senhas não coincidem. Por favor, tente novamente.'
                });
                return;
            }

            if (!criteria.length || !criteria.uppercase || !criteria.number) {
                setErrorMessage('A senha deve atender a todos os critérios.');
                setShowMessage(false);
                return;
            }

            setIsLoading(true);


            const payload = {
                ...users,
                council_code: selectedSpecialty?.council_code || "",
                specialty_id: selectedSpecialty?.value || "",
            };

            const response = await ApiService.send("post", process.env.REACT_APP_URL_API + 'users/register', payload, false);


            const {data} = ApiService.handleApiResponse(response);

            setShowMessage(true);
            setMessage(data.message);

        } catch (error) {
            if (error.response) {
                const responseData = error.response.data;
                const message = responseData.message || 'Erro desconhecido';
                const errors = responseData.data ? responseData.data.errors : null;
                if (errors && errors.length > 0) {
                    setErrorMessage(errors.join('<br/>'));
                    setShowMessage(false);
                } else {
                    setErrorMessage(message);
                    setShowMessage(false);
                }
            } else {
                setErrorMessage('Erro ao processar a requisição');
                setShowMessage(false);
            }
        } finally {
            setIsLoading(false);
        }
    };


    const renderProgressBar = () => {
        return (
            <div className="progress-container mb-4">
                <div className={`progress-step ${currentStep >= 1 ? 'active' : ''}`}>1. Informações Profissionais</div>
                <div className={`progress-step ${currentStep >= 2 ? 'active' : ''}`}>2. Dados Pessoais</div>
            </div>
        );
    };

    document.title = "Login | Plantão Rápido";

    return (
        <React.Fragment>
            <div
                className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>

                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider/>
                                        <Col lg={6}>

                                            <div className="p-lg-5 p-4">
                                                <h1>Registrar</h1>
                                                <p className="account-subtitle">Cadastro gratuito</p>
                                                {renderProgressBar()}
                                                {showMessage ? (
                                                    <div className="alert alert-primary" role="alert">
                                                        <p>Cadastro realizado</p>
                                                        <p>Por favor, valide o seu e-mail!</p>
                                                        <Link to="/login"
                                                              className="btn btn-primary w-100">Login</Link>
                                                    </div>
                                                ) : (
                                                    <form onSubmit={handleSubmit}>
                                                        {currentStep === 1 && (
                                                            <>

                                                                <div className="col-md-12 form-group">
                                                                    <label>Especialidade</label>
                                                                    <Select

                                                                        value={selectedSpecialty}
                                                                        options={specialtyFilter.map((specialty) => ({
                                                                            value: specialty.id,
                                                                            label: specialty.name,
                                                                            council_code: specialty.council_code,
                                                                        }))}
                                                                        onChange={(specialty) => {
                                                                            setUsers((prevFilters) => ({
                                                                                ...prevFilters,
                                                                                specialty_id: specialty?.value || "",
                                                                            }));
                                                                            setSelectedSpecialty(specialty);
                                                                        }}
                                                                        classNamePrefix="select"
                                                                        placeholder="Selecionar Especialidade..."
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999
                                                                            }),
                                                                            menu: base => ({...base, zIndex: 9999})
                                                                        }}
                                                                    />

                                                                </div>

                                                                {selectedSpecialty?.council_code === 'CRM' && (
                                                                    <>
                                                                        <div className="form-group">
                                                                            <label>CRM</label>
                                                                            <input
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder="CRM"
                                                                                name="crm"
                                                                                value={users?.crm}
                                                                                onChange={handleChange}/>
                                                                        </div>
                                                                        <div className="form-group col-12">
                                                                            <label>Estado</label>
                                                                            <Select
                                                                                name='uf'
                                                                                onChange={handleUfChange}
                                                                                options={ufs}
                                                                                value={ufs.find((uf) => uf.value === users.uf) || null}
                                                                                placeholder="Selecionar Estado"
                                                                                isSearchable
                                                                                menuPortalTarget={document.body}
                                                                                styles={{
                                                                                    menuPortal: base => ({
                                                                                        ...base,
                                                                                        zIndex: 9999
                                                                                    }),
                                                                                    menu: base => ({
                                                                                        ...base,
                                                                                        zIndex: 9999
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary w-100"
                                                                    disabled={selectedSpecialty == null}
                                                                    onClick={() => handleNextStep()}
                                                                >
                                                                    Próximo
                                                                </button>
                                                            </>
                                                        )}

                                                        {currentStep === 2 && (
                                                            <>
                                                                <div className="form-group">
                                                                    <label>Nome</label>
                                                                    <input className="form-control" type="text"
                                                                           placeholder="Nome completo" name="name"
                                                                           value={users.name} required={true}
                                                                           onChange={handleChange}
                                                                           disabled={selectedSpecialty?.council_code === 'CRM'}/>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label>E-mail</label>
                                                                    <input className="form-control" type="email"
                                                                           name="email" required={true}
                                                                           onChange={handleChange}
                                                                           placeholder="E-mail"/>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label>CPF/CNPJ</label>
                                                                    <Input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="cpf"
                                                                        name="cpf"
                                                                        required={true}
                                                                        placeholder="CPF/CNPJ"
                                                                        onChange={handleCpfCnpjChange}
                                                                        value={cpfCnpj || ''}
                                                                    />
                                                                </div>
                                                                <div className="form-group">
                                                                    <label>Senha</label>
                                                                    <input className="form-control" type="password"
                                                                           value={users.password}
                                                                           name="password"
                                                                           onChange={handleChange} placeholder="Senha"
                                                                           autoComplete="off"/>
                                                                </div>
                                                                <ul className="password-criteria list-unstyled">
                                                                    <li>
                                                                        <i className={`fa ${criteria.length ? "fa-check text-success" : "fa-close text-danger"}`}></i>
                                                                        {' '}6 Caracteres
                                                                    </li>
                                                                    <li>
                                                                        <i className={`fa ${criteria.uppercase ? "fa-check text-success" : "fa-close text-danger"}`}></i>
                                                                        {' '}1 Letra Maiúscula
                                                                    </li>
                                                                    <li>
                                                                        <i className={`fa ${criteria.number ? "fa-check text-success" : "fa-close text-danger"}`}></i>
                                                                        {' '}1 Número
                                                                    </li>
                                                                </ul>
                                                                <div className="form-group">
                                                                    <label>Confirmar Senha</label>
                                                                    <input
                                                                        className="form-control"
                                                                        type="password"
                                                                        name="password_confirmation"
                                                                        onChange={handleChange}
                                                                        placeholder="Confirmar Senha" autoComplete="off"
                                                                    />
                                                                </div>
                                                                {errorMessage && (
                                                                    <div className="alert alert-danger mt-2"
                                                                         role="alert">
                                                                        <div
                                                                            dangerouslySetInnerHTML={{__html: errorMessage}}/>
                                                                    </div>
                                                                )}
                                                                <button
                                                                    className="btn btn-primary w-100 position-relative"
                                                                    type="submit"
                                                                    disabled={isLoading}>
                                                                    {isLoading && (
                                                                        <div className="spinner-overlay">
                                                                            <div className="spinner-border text-light"
                                                                                 role="status">
                                                                            <span
                                                                                className="sr-only">Carregando...</span>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {isLoading ? 'Registrando...' : 'Registrar'}
                                                                </button>
                                                                <button type="button"
                                                                        className="btn btn-secondary w-100 mt-2"
                                                                        onClick={() => handlePreviousStep()}>
                                                                    Voltar
                                                                </button>
                                                            </>
                                                        )}
                                                    </form>
                                                )}
                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">Já tem uma conta ? <Link to="/login"
                                                                                                 className="fw-semibold text-primary text-decoration-underline"> Login </Link>
                                                    </p>
                                                </div>
                                            </div>

                                        </Col>

                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()} <a
                                        className="text-reset text-decoration-none" target="_blank"
                                        rel="noopener noreferrer"
                                        href={footerUrl}>{footerTitle}</a>.
                                        Todos Direitos
                                        Reservados</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>

            </div>
        </React.Fragment>
    );
};

export default Register;
